<!--
 * @Author: your name
 * @Date: 2021-05-19 17:07:01
 * @LastEditTime: 2021-09-15 11:57:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ope\src\views\content\yirongtongShop\components\yrtBanner.vue
-->
<template>
  <section class="control_box">
    <el-dialog
      :append-to-body="true"
      title="主推商品区"
      width="800px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <div>
        <div class="margin-b10">
          <el-form
            ref="floorRuleForm"
            :model="floorData"
            :rules="rules1"
            label-width="100px"
          >
            <el-form-item label="主推标题:" prop="title">
              <el-input
                v-model.trim="floorData.title"
                maxlength="6"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="跳转链接:">
              <el-input v-model.trim="floorData.linkUrl"></el-input>
            </el-form-item>
            <el-form-item
              label="商品设置:"
              v-if="this.floorData.productList.length < 10"
              required
            >
              <el-button type="primary" @click.native.prevent="showDialog()"
                >新增商品</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="floorData.productList" border max-height="500px">
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column prop="name" label="商品名称">
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                title="商品名称:"
                width="300"
                trigger="hover"
              >
                <div>{{ scope.row.name }}</div>
                <span slot="reference">{{
                  scope.row.name.substr(0, 10) + '...' + ''
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            label="商品价格"
            align="center"
          ></el-table-column>
          <el-table-column prop="imgUrl" label="图片预览" align="center">
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.imgUrl"
                :preview-src-list="scope.row.imgUrl.split(',')"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click.native.prevent="showEditDialog(scope)"
                >编辑</el-button
              >
              <el-button
                type="text"
                @click.native.prevent="
                  deleteRow(scope.$index, floorData.productList)
                "
                >删除</el-button
              >
              <el-button
                icon="el-icon-top"
                type="text"
                @click.native.prevent="up(scope.$index)"
                >上移</el-button
              >
              <el-button
                icon="el-icon-bottom"
                type="text"
                @click.native.prevent="down(scope.$index)"
                >下移</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="tip-list">
          <p>1.必须维护满10个商品，有空缺时不允许提交审核。</p>
        </div> -->
      </div>
      <div slot="footer" class="dialog-footer flex-c">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="floorSubmit('floorRuleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <item-edit-dialog
      :item-dialog-visible.sync="itemDialogVisible"
      :item-dialog-data="itemDialogData"
      @submitPopupData="submitPopupData"
    />
    <product-dialog
      :product-dialog-visible.sync="productDialogVisible"
      @getProductDialogInfo="getProductDialogInfo"
    />
  </section>
</template>

<script>
import { epecToken } from '../../utils/globalData';
import api from '../../api/cms/index';
import productDialog from './productDialog.vue'; // 选择商品
import itemEditDialog from './itemEditDialog.vue';
// 选择商品
export default {
  components: {
    productDialog,
    itemEditDialog,
  },
  props: {
    activeName: {
      type: String,
      default: '',
    },
    floorData: {
      type: Object,
      default() {
        return {
          isHidden: false,
          title: '',
          linkUrl: '',
          productList: [],
        };
      },
    },
  },
  data() {
    return {
      header: epecToken,
      dialogVisible: false,
      itemDialogVisible: false,
      itemDialogData: {},
      rules1: {
        title: [{ required: true, message: '请填写主推标题', trigger: 'blur' }],
      },

      productDialogVisible: false,
    };
  },
  watch: {
    activeName(newV, oldV) {
      console.log(newV, oldV);
      // eslint-disable-next-line eqeqeq
      this.dialogVisible = newV == 'floor1';
    },
  },
  created() {
    this.uploadImgUrl = api.fileUpload;
  },
  methods: {
    closeDialog() {
      this.$parent.choosenComments('');
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // 编辑商品
    showEditDialog(itemDialogData) {
      this.itemDialogVisible = true;
      const { $index, row } = itemDialogData;
      console.log(itemDialogData, 123123);
      this.itemDialogData = {
        $index,
        row,
      };
    },
    submitPopupData(data, itemDialogData) {
      // 点击确定返回值
      // console.log(data, 'data');
      itemDialogData.row.jumpType = data.jumpType;
      itemDialogData.row.itemlinkUrl = data.itemlinkUrl;
      console.log(this.floorData);
      this.itemDialogVisible = false;
    },

    showDialog() {
      this.productDialogVisible = true;
    },
    up(index) {
      if (index === 0) {
        return;
      }
      // 在上一项插入该项
      // eslint-disable-next-line vue/no-mutating-props
      this.floorData.productList.splice(
        index - 1,
        0,
        this.floorData.productList[index]
      );
      // 删除后一项
      // eslint-disable-next-line vue/no-mutating-props
      this.floorData.productList.splice(index + 1, 1);
    },
    down(index) {
      if (index === this.floorData.productList.length - 1) {
        return;
      }
      // 在下一项插入该项
      // eslint-disable-next-line vue/no-mutating-props
      this.floorData.productList.splice(
        index + 2,
        0,
        this.floorData.productList[index]
      );
      // 删除前一项
      // eslint-disable-next-line vue/no-mutating-props
      this.floorData.productList.splice(index, 1);
    },

    floorSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 得到所选产品的信息
    getProductDialogInfo(val) {
      val.forEach((item) => {
        const obj = {
          skuId: item.skuId,
          price: item.price,
          supplierCompanyId: item.supplierCompanyId,
          name: item.skuName,
          exportStatus: item.exportStatus,
          imgUrl: item.defaultImage,
          ...item,
        };

        let isOk = true;
        this.floorData.productList.forEach((list) => {
          if (item.skuId == list.skuId) {
            isOk = false;
            this.$message.error('重复添加商品！');
          }
        });
        if (isOk) {
          // eslint-disable-next-line vue/no-mutating-props
          this.floorData.productList.push(obj);
          if (this.floorData.productList.length > 10) {
            this.$message.error('添加商品不能超过10个');
            // eslint-disable-next-line vue/no-mutating-props
            this.floorData.productList = this.floorData.productList.slice(
              0,
              10
            );
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/theme.scss';
.control_box {
  background: #fff;
  .box-card-header {
    font-weight: 600;
  }
}
.tip-list {
  background: #f4f7ff;
  padding: 10px;
  margin-top: 10px;
  p {
    color: $c6;
    line-height: 32px;
  }
}

.oneimg-upload {
  background-color: #fff;
  border-radius: 6px;
  box-sizing: border-box;

  cursor: pointer;
}
.oneimg-upload ::v-deep .el-upload--text {
  width: 212px;
  height: 212px;
  line-height: 212px;
  border: 1px dashed #d9d9d9;
  .el-image {
    height: 100%;
  }
}
</style>
